import type { Prototype } from "../prototype-types";

export const carolynKaoPrototypes: Prototype[] = [
  {
    id: "faire-pay-email",
    name: "Faire Pay Email",
    path: "/ck/faire-pay-email",
    description: "Faire Pay email communication flows",
    owner: "Carolyn Kao",
    createdAt: "2026-04-30",
    lastUpdated: "2026-04-30",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/b367281c01366ff83ee1767a4f2e632e2283ea234e033c788d1ca72989afe06b.png",
    creationTool: "claude-code",
  },
  {
    id: "deactivate-faire-pay",
    name: "Deactivate Faire Pay",
    path: "/ck/deactivate-faire-pay",
    description:
      "Allowing retailers to disable FP at setup if they don't want to link a bank account",
    owner: "Carolyn Kao",
    createdAt: "2026-04-30",
    lastUpdated: "2026-04-30",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/99db2a93b06fa1bf617f5c495e02dcf6c0b76961108491217e2cf4fed8699d35.png",
    creationTool: "claude-code",
  },
  {
    id: "faire-pay-sprint",
    name: "Faire Pay Sprint",
    path: "/ck/faire-pay-sprint",
    description:
      "Faire Pay Clarity V2 with KYB setup flow — 'Start from setup' checkbox triggers the account-setup flow (variant 7) and lands in the V4 dashboard new user state.",
    owner: "Carolyn Kao",
    createdAt: "2026-04-28",
    lastUpdated: "2026-04-30",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/3e8f67320264e0fc6c927ba8c5117b24e91cbe44d5f56459c8d020b3d9725d02.png",
    creationTool: "claude-code",
  },
  {
    id: "early-pay",
    name: "Early Pay",
    path: "/ck/early-pay",
    description: "Paying invoices early",
    owner: "Carolyn Kao",
    createdAt: "2026-04-01",
    lastUpdated: "2026-04-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/ca3052b59014917c9c4fd6156e2eb3974626e9593928bc84d083d6bb43a6619d.png",
    creationTool: "cursor",
  },
  {
    id: "faire-pay-touchpoints",
    name: "Faire Pay Touchpoints",
    path: "/ck/faire-pay-touchpoints",
    description:
      "Faire Pay touchpoints across the retailer experience, including brand page and product discovery.",
    owner: "Carolyn Kao",
    createdAt: "2026-03-13",
    lastUpdated: "2026-04-26",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/f7abf23b4c946ce48bc53e8502da804de18af985494101a2d24d801d685b3dc0.png",
    creationTool: "cursor",
  },
  {
    id: "faire-pay-test",
    name: "Faire Pay Test",
    path: "/ck/faire-pay-test",
    description: "This is just for a test",
    owner: "Carolyn",
    createdAt: "2026-03-09",
    lastUpdated: "2026-03-09",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/a03e843ca2469e8abd5414bfd47f7c417387ff241b71e7f17526663dbb6839de.png",
    creationTool: "claude-code",
  },
  {
    id: "faire-pay-payment-modal",
    name: "Faire Pay Payment Modal",
    path: "/ck/faire-pay-payment-modal",
    description:
      "Payment modal for Faire Pay enrolled retailers. Allows users to view statement balance, due dates, autopay status, and select payment amounts (minimum, full balance, or custom) with interest projections.",
    owner: "Carolyn",
    createdAt: "2026-01-30",
    lastUpdated: "2026-01-30",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/8347fed2c7fc435441cb154575ba538fc3bfebd18f2b22759facb2ff8a9b0ffc.png",
    creationTool: "cursor",
  },
  {
    id: "multistep-kyb",
    name: "Multistep KYB",
    path: "/ck/multistep-kyb",
    description:
      "Multistep KYB verification flow with multiple variants including Pay as you go (variant 7) which adds a 'Choose how to pay' step letting retailers select between monthly billing or pay-as-you-go for invoices. Collects business info, address, owner details, and bank account.",
    owner: "Carolyn",
    createdAt: "2026-02-04",
    lastUpdated: "2026-03-04",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/eba47f8818706a662f5aa29b374a543cfdd107a21355ee589a297973db2aa671.png",
    creationTool: "cursor",
  },
  {
    id: "faire-checkout-replica",
    name: "Faire Checkout Replica",
    path: "/ck/faire-checkout-replica",
    description:
      "Replica of the Faire checkout page with store info, shipping options, payment methods (including Faire Pay with credit limit warning), and order summary.",
    owner: "Carolyn",
    createdAt: "2026-02-05",
    lastUpdated: "2026-02-06",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/6d4ea168f89326776b3298e1a76858e0cf7558d25ad26ba2bf90b8e0116bc38d.png",
    creationTool: "cursor",
  },
  {
    id: "ck-brand-portal-issues-page",
    name: "Brand Portal Issues Page",
    path: "/ck/brand-portal-issues-page",
    description:
      "Brand portal Issues page — Reported issues tab with Open/Disputed status filters and issue table.",
    owner: "Carolyn Kao",
    createdAt: "2026-07-30",
    lastUpdated: "2026-07-30",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/ck-brand-portal-issues-page.png",
    creationTool: "claude-code",
  },
  {
    id: "ck-net-terms-upsell",
    name: "Net terms upsell at checkout",
    path: "/ck/net-terms-upsell",
    description: "Fork of the combined inline treatment (accordion expanded, V1 amount copy) plus the order-summary banner — prompting a returning retailer saved on Pay on Shipment to consider net terms at checkout.",
    owner: "Carolyn Kao",
    createdAt: "2026-08-15",
    lastUpdated: "2026-08-15",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/ck-net-terms-upsell.png",
    creationTool: "cursor",
  },
  {
    id: "ck-opening-soon-confirmation-modal",
    name: "Opening Soon confirmation modal",
    path: "/ck/opening-soon-confirmation-modal",
    description:
      "Modal on the retailer orders page to confirm previously held Opening Soon orders.",
    owner: "Carolyn Kao",
    createdAt: "2026-08-22",
    lastUpdated: "2026-08-22",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/ck-opening-soon-confirmation-modal.png",
    creationTool: "cursor",
    project: "Opening Soon confirmation modal",
    figmaLink:
      "https://www.figma.com/design/56tf0bME7E6uK2yRRJYf7N/OS-progressive-IDV-pilot?node-id=646-93743",
  },
];
